import type { SVGProps } from 'react';

const SvgShareLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M13.02 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.42-1.43a7.94 7.94 0 0 1-3.9 1.62M4.03 12c0-4.05 3.03-7.41 6.95-7.93V2.05C5.95 2.58 2.03 6.84 2.03 12s3.92 9.42 8.95 9.95v-2.02c-3.92-.52-6.95-3.88-6.95-7.93m15.92-1h2.02c-.2-2.01-1-3.84-2.21-5.32l-1.43 1.43c.86 1.1 1.44 2.43 1.62 3.89m-1.61-6.74a10 10 0 0 0-5.32-2.21v2.02c1.46.18 2.79.76 3.9 1.62zm-.01 12.64 1.43 1.42A9.95 9.95 0 0 0 21.97 13h-2.02a7.94 7.94 0 0 1-1.62 3.9" />
    <path d="M16 11.1C16 8.61 14.1 7 12 7s-4 1.61-4 4.1c0 1.66 1.33 3.63 4 5.9 2.67-2.27 4-4.24 4-5.9m-4 .9a1.071 1.071 0 0 1 0-2.14A1.071 1.071 0 0 1 12 12" />
  </svg>
);
export default SvgShareLocation;
